import { render, staticRenderFns } from "./SenderAddressList.vue?vue&type=template&id=0077aba0&scoped=true&"
import script from "./SenderAddressList.vue?vue&type=script&lang=js&"
export * from "./SenderAddressList.vue?vue&type=script&lang=js&"
import style0 from "./SenderAddressList.vue?vue&type=style&index=0&id=0077aba0&lang=scss&scoped=true&"
import style1 from "./SenderAddressList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0077aba0",
  null
  
)

export default component.exports